module.exports = __webpack_public_path__ + "img/feature-1-ikea-mobile.ff3118f1.png";